import { z } from 'zod/v4';

export const FacilityDetailsRouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing implementationId' }),
  facilityId: z.string({ message: 'Missing facilityId' }),
});
